import { render, staticRenderFns } from "./showfile.vue?vue&type=template&id=6b02a00c"
import script from "./showfile.vue?vue&type=script&lang=js"
export * from "./showfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports